/* eslint-disable */
export default {
  schedule: 'Schedule Meeting',
  prompt: 'Please authorise RingCentral to access your account information.',
  saveAsDefault: 'Save as default',
  launchMeeting: 'Launch Meeting',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
